<template>
	<ModelForm
		:modelId="modelId"
		resource="reasonStates"
		:modelInfo="defaultModelInfo"
		v-slot="slotProps"
		@fetch="$emit('update:unableEdit',!$hasPermission('reasonState.edit'))"
		:successCallback="successCallback"
	>
		<b-form-row>
			<b-form-group :disabled="unableEdit" class="col-12" label="Descripcion razon de estado">
				<b-form-input
					type="text"
					size="sm"
					v-model="slotProps.modelInfo.label"
					required
				/>
			</b-form-group>

			<b-form-group
				:disabled="unableEdit"
				class="col-12 col-md-6"
				label="Seleccione a que tipo de estado cambia"
			>
				<b-form-select
					size="sm"
					:disabled="
						modelId > 0 && slotProps.modelInfo.parentId !== null
					"
					v-model="slotProps.modelInfo.toStatus"
					:options="transportServiceStatusOpts"
					required
					@input="loadReasonOptions(slotProps.modelInfo.toStatus)"
				/>
			</b-form-group>

			<b-form-group
				:disabled="unableEdit"
				class="col-12 col-md-6"
				label="Razon padre"
				v-if="modelId < 0 && slotProps.modelInfo.parentId"
			>
				<b-overlay
					:show="loading"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="d-inline-block"
					style="width: 100%"
				>
					<b-form-select
						size="sm"
						style="width: 100%"
						v-model="slotProps.modelInfo.parentId.id"
						:options="reasonsOptions"
					/>
				</b-overlay>
			</b-form-group>

			<b-form-group
				:disabled="unableEdit"
				class="col-12 mt-3"
				label="Marcar este estado como"
				v-if="modelId != -1"
			>
				<b-form-radio
					v-model="slotProps.modelInfo.status"
					name="active"
					value="active"
					>Activo</b-form-radio
				>
				<b-form-radio
					v-model="slotProps.modelInfo.status"
					name="inactive"
					value="inactive"
					>Inactivo</b-form-radio
				>
			</b-form-group>
		</b-form-row>

		<hr />
		<div class="text-right">
			<b-button :disabled="unableEdit" variant="primary" type="submit">{{
				modelId > 0 ? "Actualizar" : "Guardar"
			}}</b-button>
		</div>
	</ModelForm>
</template>

<script>
import ModelForm from "../../helpers/ModelForm.vue";
import api from "../../../api.js";

export default {
	props: {
		modelId: {
			type: Number,
			required: false,
			default: -1
		},
		modalId: {
			type: String,
			required: true
		},
		unableEdit: Boolean
	},
	computed: {
		transportServiceStatusOpts() {
			return this.$root.auxVars.transportServiceStatusOpts
		}
	},
	components: { ModelForm },
	data() {
		return {
			defaultModelInfo: {
				label: "",
				parentId: {
					id: ""
				},
				toStatus: "",
				status: "active"
			},
			reasonsOptions: [],
			loading: false
		};
	},
	methods: {
		successCallback(event) {
			if (event.data) this.$emit("modal-id", event.data);
			this.$root.auxVars.loadResourcesOpts({
				vm: this,
				resourceNames: ["reasonStates"],
				forceRefresh: true
			});
			this.$root.auxVars.loadResourcesOpts({
				vm: this,
				resourceNames: ["reasonStatesActive"],
				forceRefresh: true
			});
		},
		loadReasonOptions(status) {
			this.loading = true;
			this.reasonsOptions = [];
			api(this)
				.get(`reasonStates/list?status=${status}`)
				.then(response => {
					this.reasonsOptions = response.data.map(item => ({
						value: item.id,
						text: item.label
					}));
				})
				.finally(() => {
					this.loading = false;
				});
		}
	},
	mounted() {
		this.$root.auxVars.loadResourcesOpts({
			vm: this,
			resourceNames: ["reasonStates"]
		});
	}
};
</script>

<style></style>
